import {IElement, ITextAttributes, ITextSelectionInformation} from 'routes/private/Editor/types';
import { execCommandToSelectedText, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontFamilyResolver = ( element: IElement, value: string, textSelectionInformation?: ITextSelectionInformation ) => {
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("fontFamily", (element.attributes as ITextAttributes), textSelectionInformation, value);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}